import React, { useContext } from "react";
import { Avatar, Image } from "antd";
import { getAvatarBackgroundColor } from "../../../helpers/utility";
import { UserContext } from "../../../context/UserContext";

const UserSettingsAvatar = ({ size = 40 }) => {
  const { userDetails } = useContext(UserContext);
  const selectedColor = getAvatarBackgroundColor(userDetails?.first_name);

  if (userDetails?.activeOrg?.usr_profile_pic) {
    return (
      <Image
        src={userDetails?.activeOrg?.usr_profile_pic}
        alt="Profile"
        width={size}
        height={size}
        style={{ borderRadius: "50%", flexShrink: 0 }}
        preview={false}
      />
    );
  }

  return (
    <Avatar
      style={{
        flexShrink: 0,
        backgroundColor: userDetails?.profile_pic ? "" : selectedColor,
      }}
      size={size}
    >
      <span style={{ fontSize: size <= 40 ? "18px" : "20px" }}>
        {userDetails?.first_name?.slice(0, 1).toUpperCase()}
      </span>
    </Avatar>
  );
};

export default UserSettingsAvatar;
